/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import GridOnOutlinedIcon from "@mui/icons-material/GridOnOutlined";
import ImageAspectRatioOutlinedIcon from "@mui/icons-material/ImageAspectRatioOutlined";
import { IMAGE_FORMAT_CROPPED, IMAGE_FORMAT_SCALED } from "cms/images/image-inpage-editor-v2/image-helpers";

const SelectImageFormat = (props) => {
    
    const {
        onChange,
        selectedFormat,
        FORMATS,
        disableScale = false
    } = props || {};
    
    
    return (
        <>
            <div className='component-box' style={{
                // border: '1px solid red',
                display: "flex", gap: "12px", alignContent: "center" }}
            >
                <ToggleButtonGroup
                    color='primary'
                    size='small'
                    value={selectedFormat}
                    onChange={onChange}
                    exclusive
                    aria-label='Image Style'
                >
                    <ToggleButton
                        value={IMAGE_FORMAT_CROPPED}
                    >
                        <GridOnOutlinedIcon />{" "}{FORMATS.CROPPED_FOCUS.name}
                    </ToggleButton>
                    
                    {!disableScale &&
                        <ToggleButton
                            value={IMAGE_FORMAT_SCALED}
                        >
                            <ImageAspectRatioOutlinedIcon />{" "}{FORMATS.SCALED_IMAGE.name}
                        </ToggleButton>
                    }
                </ToggleButtonGroup>
            
            </div>
        </>
    );
};

export default SelectImageFormat;
